import type { Trackers, UG, Usina } from "./types";

function trackersComponentHasTrackers(trackers?: Trackers): boolean {
  return (trackers?.amount ?? 0) > 0;
}

function ugHasTrackers(ug: UG): boolean {
  return trackersComponentHasTrackers(ug.components?.trackers);
}

export function usinaHasTrackers(usina: Usina): boolean {
  if (trackersComponentHasTrackers(usina.components?.trackers)) return true;
  return usina.uGs?.some(ugHasTrackers) ?? false;
}

export function buildUsinaHasTrackersByRopInputId(
  usinas: Usina[],
): Map<number, boolean> {
  const map = new Map<number, boolean>();

  for (const usina of usinas) {
    const hasTrackers = usinaHasTrackers(usina);
    map.set(usina.usinaIds.ropInputId, hasTrackers);

    const numericId = Number(usina.usinaIds.id);
    if (!Number.isNaN(numericId)) {
      map.set(numericId, hasTrackers);
    }
  }

  return map;
}

export function findUsinaByRopInputId(
  usinas: Usina[],
  ropInputId: number,
): Usina | undefined {
  return usinas.find((usina) => usina.usinaIds.ropInputId === ropInputId);
}

export function findUsinaByName(
  usinas: Usina[],
  usinaName: string,
): Usina | undefined {
  return usinas.find(
    (usina) =>
      usina.name?.localeCompare(usinaName, "pt-BR", { sensitivity: "base" }) ===
      0,
  );
}
